enum CustomFieldTypes {
  CHECKBOX = 'checkbox',
  DATE_PICKER = 'date',
  LIST_SINGLE = 'select',
  LIST_MULTI = 'multiselect',
  TEXT_SINGLE = 'text',
  TEXT_MULTI = 'textarea',
}

export default CustomFieldTypes;
